<template>
  <div class="w-full bg-gray-100 py-8 sm:py-12">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-center gap-4 sm:gap-6">
        <div v-for="o in 4" :key="o" class="flip-container">
          <div class="flip-card group cursor-pointer">
            <!-- 正面 -->
            <div
              class="flip-card-front bg-gray-800 text-white w-[280px] sm:w-[300px] lg:w-[320px] h-[160px] sm:h-[180px] lg:h-[200px] rounded-xl bg-cover bg-center flex items-center justify-center shadow-lg"
              style="
                background-image: linear-gradient(
                    rgba(0, 0, 0, 0.3),
                    rgba(0, 0, 0, 0.3)
                  ),
                  url(https://media.giphy.com/media/LwIyvaNcnzsD6/giphy.gif);
              "
            >
              <h2 class="text-2xl sm:text-3xl font-bold drop-shadow-2xl">
                OCEAN
              </h2>
            </div>

            <!-- 背面 -->
            <div
              class="flip-card-back bg-gradient-to-br from-gray-700 to-gray-900 text-white w-[280px] sm:w-[300px] lg:w-[320px] h-[160px] sm:h-[180px] lg:h-[200px] rounded-xl p-5 sm:p-6 flex flex-col justify-center shadow-lg"
            >
              <h3 class="text-lg sm:text-xl font-bold mb-2 sm:mb-3">Angular</h3>
              <p class="text-xs sm:text-sm leading-relaxed text-gray-300">
                Good tools make application development quicker and easier to
                maintain than if you did everything by hand.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicCard",
  props: {
    cateTitle: String,
    cateSubTitle: String,
    cateDesc: String,
  },
};
</script>

<style scoped>
.flip-card {
  position: relative;
  perspective: 1000px;
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  transition: transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.flip-card-front {
  transform: rotateY(0deg);
}

.flip-card-back {
  transform: rotateY(-180deg);
}

.flip-card:hover .flip-card-front {
  transform: rotateY(180deg);
}

.flip-card:hover .flip-card-back {
  transform: rotateY(0deg);
}
</style>
